import { useEffect, useState } from 'react';
import { RiExpandUpDownLine } from 'react-icons/ri';
import { FaApple, FaEthereum } from 'react-icons/fa';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useSession } from '@/contexts/LitSessionProvider';
import { SESSION_LENGTHS } from '@/hooks/LitSessionContext/useLitSession';
import Seo from '@/components/shared/Seo';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import MfaAuthData from '@/components/userSettings/MfAuthData';
export default function SettingsSecurityPage() {
  const {
    sessionLength,
    MFAInfo,
    currentAuthMethod,
    setSessionLength
  } = useSession();
  const [isClient, setIsClient] = useState(false);
  const checkAuthMethod = (authMethodTypes: number[]): boolean => {
    return authMethodTypes?.includes(currentAuthMethod?.authMethodType);
  };
  const secData = [{
    title: 'Google',
    status: checkAuthMethod([5, 6]) ? 'Synced' : 'Add as an Additional Login Method',
    icon: <ImageWithFallback src='/static/images/google_logo.png' width={16} height={16} alt='google' className='mr-4' />,
    kind: checkAuthMethod([5, 6]) ? '' : 'connect',
    className: checkAuthMethod([5, 6]) ? 'text-green-400' : 'text-genius-cream'
  }, {
    title: 'EVM Wallet',
    status: checkAuthMethod([1]) ? 'Synced' : 'Add as an Additional Login Method',
    icon: <FaEthereum />,
    kind: checkAuthMethod([1]) ? '' : 'connect',
    className: checkAuthMethod([1]) ? 'text-genius-pink' : 'text-genius-cream'
  }, {
    title: 'Apple',
    status: checkAuthMethod([8]) ? 'Coming Soon' : 'Coming Soon',
    icon: <FaApple />,
    kind: '',
    className: checkAuthMethod([8]) ? 'text-genius-pink' : 'text-genius-cream'
  }].filter(item => item.status == 'Synced');
  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient) {
    return;
  }
  return (
    //TODO investigate - messes up the UI

    <div className='flex flex-col lg:flex-row overflow-y-scroll' data-sentry-component="SettingsSecurityPage" data-sentry-source-file="index.tsx">
      <Seo nofollow noindex title='Security • Genius Terminal • Trade Crypto Like a Genius' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <div className='bg-genius-indigo h-screen grow'>
        <div className='w-full flex justify-between items-center mt-4 pl-4'>
          <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="index.tsx" />
        </div>
        <div className='w-full flex justify-between items-center p-5'>
          <div className='flex flex-col w-2/3 title text-genius-cream text-[20px] font-light'>
            Login Method
          </div>
        </div>
        <div className='sec-wrapper'>
          {secData.map((infoItem, index) => {
            return <div className='w-full px-5 py-4 flex justify-between items-center' key={index}>
                <div className='flex items-center gap-x-2'>
                  {infoItem.icon}
                  <div className='flex flex-col gap-y-[2px]'>
                    <p className='text-base/4 text-genius-cream'>{infoItem.title}</p>
                    <p className='text-xs/3 text-genius-cream/50'>
                      {`Status: `}
                      {` `}
                      <span className={infoItem.className}>{infoItem.status}</span>
                    </p>
                  </div>
                </div>
              </div>;
          })}
        </div>
        <div className='ml-4 py-4 title text-genius-cream text-2xl/6 font-light leading-3'>
          <p>Two Factor Authentication</p>
          <p className='mt-4 text-xs leading-4 text-genius-cream/50'>
            Add <span className='text-genius-cream'>one extra method</span> of authenticating your
            account. Choose from the options below
          </p>
        </div>
        <div className='mfa-wrapper'>
          <div className='w-full flex justify-between items-center'>
            <div className='flex flex-col w-full'>
              <MfaAuthData MFAInfo={MFAInfo} data-sentry-element="MfaAuthData" data-sentry-source-file="index.tsx" />
            </div>
          </div>
        </div>
        <div className='session-wrapper'>
          <div className='w-full flex items-center pl-4'>
            <div className='flex flex-col title text-genius-cream text-2xl/6 font-light py-4'>
              Session
            </div>
          </div>
          <div className='w-full px-5 py-4 flex justify-between items-center'>
            <div className='flex items-center'>
              <div className='flex flex-col gap-y-[2px]'>
                <p className='text-md text-genius-cream'>Session Length</p>
                <p className='text-genius-cream/50 text-xs/3'>
                  We will automatically log you out after:
                </p>
              </div>
            </div>
            <div className='control'>
              <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="index.tsx">
                <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="index.tsx">
                  <div className='flex items-center justify-between text-genius-cream gap-4 px-2 py-2 rounded-md cursor-pointer'>
                    <p className='text-xs/3'>{SESSION_LENGTHS[sessionLength]}</p>
                    <RiExpandUpDownLine size={12} data-sentry-element="RiExpandUpDownLine" data-sentry-source-file="index.tsx" />
                  </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent className='text-xs font-medium bg-genius-indigo text-genius-cream/50' data-sentry-element="DropdownMenuContent" data-sentry-source-file="index.tsx">
                  <DropdownMenuGroup data-sentry-element="DropdownMenuGroup" data-sentry-source-file="index.tsx">
                    <DropdownMenuItem onClick={() => {
                      setSessionLength(SESSION_LENGTHS['1 hour']);
                    }} data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                      1 Hour
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => {
                      setSessionLength(SESSION_LENGTHS['6 hours']);
                    }} data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                      6 Hours
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => {
                      setSessionLength(SESSION_LENGTHS['12 hours']);
                    }} data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                      12 Hours
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => {
                      setSessionLength(SESSION_LENGTHS['1 day']);
                    }} data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                      1 Day
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => {
                      setSessionLength(SESSION_LENGTHS['3 days']);
                    }} data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                      3 Days
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => {
                      setSessionLength(SESSION_LENGTHS['1 week']);
                    }} data-sentry-element="DropdownMenuItem" data-sentry-source-file="index.tsx">
                      1 Week
                    </DropdownMenuItem>
                  </DropdownMenuGroup>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}